import React, { useEffect, useContext } from "react";
import { useState } from "react";
import "./guageChart.scss";
import { UserContext } from "../../../layouts/MainLayout";

const GuageChart = ({
  id,
  targetValue,
  additionalPercentage,
  maxAdditionalPercentage,
  value,
  size,
  showIndicator = false,
  usedForDashboard = false,
  grayTheme = false,
  semiCircle = false,
  mode,
}) => {
  const { appTheme } = useContext(UserContext);

  const [indicatorVisible, setIndicatorVisible] = useState(showIndicator);
  const [gaugeTargetValue, setGaugeTargetValue] = useState(targetValue);
  const [displayedArcColor, setDisplayedArcColor] = useState("");

  const getArcPoint = (c1, c2, radius, angle) => {
    return [c1 + Math.cos(angle) * radius, c2 + Math.sin(angle) * radius];
  };

  const renderGauge = () => {
    const canvasSize = size ? parseFloat(size) : 1;
    const canvas = document.getElementById(id);
    if (!canvas) return;
    canvas.height = `${140 * canvasSize}`;
    canvas.width = `${280 * canvasSize}`;
    const markerVal = value < 0 ? 0 : value;

    if (semiCircle && (mode === "OFFLINE" || mode === "STANDBY")) {
      showIndicator = false;
      setIndicatorVisible(showIndicator);
    }

    const maxRange =
      Math.round(
        (targetValue + targetValue * (additionalPercentage / 100)) * 100
      ) / 100;
    const maxRange2 =
      Math.round(
        (targetValue + targetValue * (maxAdditionalPercentage / 100)) * 100
      ) / 100;

    const valuePercent = Math.floor((markerVal / maxRange) * 100);
    const maxValuePercent = markerVal > maxRange ? 100 : valuePercent;

    let arcAngleRange;
    let arcStartAngle;

    if (semiCircle) {
      arcAngleRange = 180; // To Assign the semicircle Angle range
      arcStartAngle = 180; // To Assign Start angle for the semicircle
    } else {
      arcAngleRange = 250;
      arcStartAngle = 215;
    }

    let arcAnglePercent = Math.floor((arcAngleRange * maxValuePercent) / 100);
    const arcAngle = arcStartAngle - arcAnglePercent;

    let arcColor;

    if (semiCircle) {
      arcColor =
        markerVal === 0
          ? appTheme === "light"
            ? "#EEEEEE"
            : "#343434"
          : markerVal <= maxRange
          ? "#07D95A" // green
          : markerVal <= maxRange2
          ? "#FFD012" // yellow
          : "#FF2B02"; // red
    } else {
      arcColor =
        markerVal === 0
          ? appTheme === "light"
            ? "#ffffff"
            : "#343434"
          : markerVal <= maxRange
          ? "#07D95A"
          : markerVal <= maxRange2
          ? "#FFD012"
          : "#FF2B02";
    }

    setDisplayedArcColor(arcColor);

    const canvasW = canvas.getBoundingClientRect().width;
    const canvasH = canvas.getBoundingClientRect().height;
    const cX = Math.round((canvasW / 2.01) * 100) / 100;
    let cY = Math.round((canvasH / 1.7) * 100) / 100;
    let cR = Math.round((canvasH / 2.2) * 100) / 100;

    const ctx = canvas.getContext("2d");

    ctx.clearRect(0, 0, canvasW, canvasH);
    ctx.beginPath();

    semiCircle
      ? ctx.arc(cX, cY, cR, (Math.PI / -180) * 180, (Math.PI / -180) * 0, false)
      : ctx.arc(
          cX,
          cY,
          cR,
          (Math.PI / 180) * 145,
          (Math.PI / -180) * -35,
          false
        );

    if (!grayTheme) {
      ctx.shadowColor = "rgba(113, 89, 166, 0.3)";
      ctx.shadowOffsetX = 0;
      ctx.shadowBlur = 1;
    }
    semiCircle ? (ctx.lineWidth = 40) : (ctx.lineWidth = 18);

    ctx.lineCap = "round";

    semiCircle
      ? (ctx.strokeStyle = appTheme === "light" ? "#EEEEEE" : "#343434")
      : (ctx.strokeStyle = appTheme === "light" ? "white" : "#2F2F2F");

    ctx.shadowColor = "rgba(113, 89, 166, 0.3)";
    ctx.shadowOffsetX = 0;
    ctx.shadowBlur = 15;

    if (semiCircle) {
      ctx.shadowColor = "white";
      ctx.shadowOffsetX = 0;
      ctx.shadowBlur = 0;
    }

    ctx.stroke();

    ctx.beginPath();

    // X-Axis, Y-Axis, Radius, Start Angle, End Angle, ClockWise & Math.PI = 180 Degree

    if (semiCircle) {
      // To Cut the Range Level Display at 180 degree Semi-Cricle point

      if (markerVal === 0) {
        ctx.arc(cX, cY, cR, (Math.PI / 180) * 180, (Math.PI / -180) * 0, false);
      } else if (markerVal === 1) {
        ctx.arc(
          cX,
          cY,
          cR,
          (Math.PI / 180) * 180,
          (Math.PI / -180) * 179,
          false
        );
      } else if (markerVal >= maxRange2) {
        ctx.arc(cX, cY, cR, (Math.PI / 180) * 180, (Math.PI / -180) * 0, false);
      } else {
        ctx.arc(
          cX,
          cY,
          cR,
          (Math.PI / 180) * 180,
          (Math.PI / -180) * (arcAngle >= 180 ? 179 : arcAngle),
          false
        );
      }
    } else {
      ctx.arc(
        cX,
        cY,
        cR,
        (Math.PI / 180) * 145,
        (Math.PI / -180) * arcAngle,
        false
      );
    }

    // }// last angle range is 215 to -35

    semiCircle ? (ctx.lineWidth = 40) : (ctx.lineWidth = 8);

    if (grayTheme) {
      semiCircle ? (ctx.lineWidth = 40) : (ctx.lineWidth = 18);
    }

    ctx.lineCap = "round";

    ctx.strokeStyle = arcColor;
    ctx.stroke();

    if (showIndicator) {
      const valuePercent1 = targetValue
        ? Math.floor((targetValue / maxRange) * 100)
        : 0;
      const maxValuePercent1 = targetValue > maxRange ? 100 : valuePercent1;
      const arcAnglePercent1 = Math.floor(
        (arcAngleRange * maxValuePercent1) / 100
      );
      const arcAngle1 = arcStartAngle - arcAnglePercent1;

      const cord = getArcPoint(cX, cY, cR - 40, (Math.PI / -180) * arcAngle1);
      const cord1 = getArcPoint(
        cX,
        cY,
        cR + 20,
        (Math.PI / -180) * (arcAngle1 - 3)
      );
      const cord2 = getArcPoint(
        cX,
        cY,
        cR + 20,
        (Math.PI / -180) * (arcAngle1 + 3)
      );
      const cord3 = getArcPoint(
        cX,
        cY,
        cR + 25,
        (Math.PI / -180) * (arcAngle1 - 1)
      );
      if (arcAngle1 > 160) {
        cord3[0] = cord3[0] - 30;
        cord3[1] = cord3[1] + 10;
      } else if (arcAngle1 > 90) {
        cord3[0] = cord3[0] - 30;
      } else if (arcAngle1 < 0) {
        cord3[0] = cord3[0] + 0;
        cord3[1] = cord3[1] + 5;
      }

      ctx.beginPath();
      ctx.moveTo(cord[0], cord[1]);
      ctx.lineTo(cord1[0], cord1[1]);
      ctx.lineTo(cord2[0], cord2[1]);
      ctx.fillStyle = appTheme === "dark" ? "#FFFFFF" : "#3C3C3C";
      ctx.fill();

      // Target Value Text Specs
      ctx.font = "bold 24px Open Sans";
      ctx.fillStyle = appTheme === "dark" ? "#FFFFFF" : "#989898";

      const rotationAngle = (50 * Math.PI) / 180; // To Convert degrees to radians

      const textX = cord3[0];
      const textY = cord3[1];

      // To Save the current canvas context state
      ctx.save();

      // To Apply the rotation transformation
      if (targetValue === 0) {
        ctx.translate(textX + 5, textY + 15); // To Move to the text position
        ctx.rotate(1.5); // To Apply the rotation
      } else {
        ctx.translate(textX, textY); // To Move to the text position
        ctx.rotate(rotationAngle); // To Apply the rotation
      }
      ctx.translate(-textX - 25, -textY - 2); // To Move back to the original position

      ctx.fillText(`${targetValue}`, cord3[0], cord3[1]);
    }

    // Capturing the Updated Values
    setIndicatorVisible(showIndicator);
    setGaugeTargetValue(targetValue);

    if (mode === "OFFLINE" || mode === "STANDBY") {
      setDisplayedArcColor("#ffffff");
    }
  };
  useEffect(() => {
    setTimeout(() => {
      renderGauge();
    }, 300);
  }, [value, targetValue, showIndicator, grayTheme, size, mode, appTheme]);
  return (
    <canvas
      id={id}
      data-canvas-data={JSON.stringify({
        gaugeTargetValue,
        indicatorVisible,
        displayedArcColor,
      })}
    />
  );
};

export default GuageChart;
